module.exports = __webpack_public_path__ + "static/img/wdkq-01.b33e488.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wdkq-01.svg
// module id = rd24
// module chunks = 1